import { useCallback } from 'react'

import { useTranslation } from 'react-i18next'

import ErrorImage from 'shared/images/error.png'
import { getApiErrorMessage } from 'shared/lib/errorText'
import { PopupContent } from 'shared/ui/poup-content'

import { useDialogBottomSheet } from './useDialogBottomSheet'

export function useApiErrorDialog() {
  const { t } = useTranslation()
  const { openDialog, closeDialog } = useDialogBottomSheet()
  const title = t('error')
  const button = t('close')
  const fallbackDescription = t('error_popup_description')

  const showErrorDialog = useCallback(
    (description: string | null) => {
      openDialog({
        isDialog: false,
        child: (
          <PopupContent
            image={ErrorImage}
            title={title}
            button={button}
            description={description || fallbackDescription}
            onClick={closeDialog}
          />
        ),
      })
    },
    [button, closeDialog, fallbackDescription, openDialog, title],
  )

  const showApiErrorDialog = useCallback(
    (error: unknown) => {
      const description = getApiErrorMessage(error)

      showErrorDialog(description)
    },
    [showErrorDialog],
  )

  return {
    showApiErrorDialog,
    showErrorDialog,
  }
}
